import {
  REGANTO_DEZINER_FAILED,
  REGANTO_DEZINER_REQUEST,
  REGANTO_DEZINER_SUCCESS,
} from "app/redux/actions/SeriesProduct/RegantoDeziner/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const regantoDezinerReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case REGANTO_DEZINER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_DEZINER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_DEZINER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
